/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ProcessFragment = {
  __typename: "Process"
  id: string
  copyId?: string | null
  createdAt?: string | null
  error?: string | null
  finished?: boolean | null
  originId?: string | null
  originType?: string | null
  targetId?: string | null
  targetType?: string | null
  updatedAt?: string | null
  options?: { __typename: "ProcessOptions"; recursive?: boolean | null } | null
}

export const ProcessFragmentDoc = gql`
  fragment Process on Process {
    id
    copyId
    createdAt
    error
    finished
    options {
      recursive
    }
    originId
    originType
    targetId
    targetType
    updatedAt
  }
`
